import { createAction } from "@reduxjs/toolkit";

export const showBackButtonAction = createAction('showBackButton', function prepare(show: boolean) {
    return {
        payload: {
            show
        },
    }
});
